import React, { Fragment } from "react";

import FormCheckbox from "../../components/form/FormCheckbox";
import ModalCheckboxGrid from "../../components/modal/ModalCheckboxGrid";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import {
  ITEM_CARD_NARRATIVE_LIST_VIEW,
  ITEM_CARD_SEQUENCE_LIST_VIEW,
  MINDMAP_VIEW,
  NARRATIVE_VIEW,
  TIMELINE_VIEW
} from "../../constants/identifiers";

export const wrapCheckbox = (checkbox, key) => {
  let component = checkbox;
  //#!if iOS === true
// component = (
// <ModalRow key={key}>
// <ModalField>{checkbox}</ModalField>
// </ModalRow>
// );
  //#!endif
  return component;
};

export const wrapCheckboxGroup = (checkboxes, label) => {
  let component = null;
  //#!if iOS === true
// component = (
// <ModalGroup key={label} label={label}>
// {checkboxes}
// </ModalGroup>
// );
  //#!else
  component = (
    <ModalField key={label} label={label}>
      {checkboxes.length ? (
        <ModalCheckboxGrid columns={1}>{checkboxes}</ModalCheckboxGrid>
      ) : (
        <div className="modalCheckboxEmpty">None</div>
      )}
    </ModalField>
  );
  //#!endif
  return component;
};

export const wrapComponents = (children, listLabel, showButton, buttonOnClick, buttonLabel) => {
  let component = null;
  //#!if iOS === true
// component = <Fragment key={listLabel}>{children}</Fragment>;
  //#!else
  component = (
    <ModalGroup
      key={listLabel}
      label={listLabel}
      showButton={showButton}
      buttonOnClick={buttonOnClick}
      buttonLabel={buttonLabel}
    >
      <ModalRow>
        <ModalField>{children}</ModalField>
      </ModalRow>
    </ModalGroup>
  );
  //#!endif
  return component;
};

export const checkboxForDefinitionObject = (obj, onChange, disabled = false) =>
  wrapCheckbox(
    <FormCheckbox
      key={obj.id}
      label={obj.label}
      checkboxState={obj.enabled}
      onChange={state => onChange(obj.id, state)}
      disabled={disabled}
    />,
    obj.id
  );

export const getShouldShowRelationshipOptions = activeViewType =>
  activeViewType === TIMELINE_VIEW ||
  activeViewType === NARRATIVE_VIEW ||
  activeViewType === MINDMAP_VIEW ||
  activeViewType === ITEM_CARD_SEQUENCE_LIST_VIEW ||
  activeViewType === ITEM_CARD_NARRATIVE_LIST_VIEW;
